import LabelIntruso from "@base/LabelIntruso/LabelIntruso"

export default LabelIntruso;
